import React from 'react';
import { Container } from '../ui/Container';
import { SectionHeading } from '../ui/SectionHeading';
import { CheckIcon } from 'lucide-react';
export const TargetAudienceSection: React.FC = () => {
  const criteria = ['You acquire companies with $500K–$25M in EBITDA', 'You have a defined investment thesis and clear buying criteria', 'You want to see deals before they hit a broker or teaser list', "You're tired of auctions, recycled deal flow, or empty referrals"];
  return <section className="w-full bg-gradient-to-br from-dark-900 via-dark-800 to-dark-700 py-32 relative overflow-hidden" data-id="element-686">
      <div className="absolute inset-0 bg-[url('https://transparenttextures.com/patterns/carbon-fibre.png')] opacity-5" data-id="element-687" />
      <div className="absolute inset-0 bg-gradient-to-br from-[#00c853]/5 via-transparent to-transparent" data-id="element-688" />
      <div className="absolute right-0 top-0 w-1/2 h-full bg-gradient-to-l from-[#00c853]/3 via-transparent to-transparent" data-id="element-689" />
      <Container className="relative" data-id="element-690">
        <div className="max-w-4xl mx-auto" data-id="element-691">
          <SectionHeading title="Is Getdealflow.ai Right For You?" centered className="text-white" data-id="element-692" />
          <div className="text-center mb-16 space-y-6" data-id="element-693">
            <p className="text-xl text-gray-300" data-id="element-694">
              We're not a broker. We're not a database. And we're not a generic
              lead gen service.
            </p>
            <p className="text-xl text-gray-300" data-id="element-695">
              We're a fully-managed sourcing engine for private equity teams
              serious about pipeline velocity, exclusivity, and quality.
            </p>
          </div>
          <div className="bg-dark-800/50 backdrop-blur-sm rounded-2xl p-8 border border-dark-600" data-id="element-696">
            <h3 className="text-2xl font-semibold mb-8 text-center text-white" data-id="element-697">
              You're a great fit if:
            </h3>
            <div className="space-y-6" data-id="element-698">
              {criteria.map((criterion, index) => <div key={index} className="flex items-center gap-2 p-4 rounded-lg transition-colors hover:bg-dark-700/50" data-id="element-699">
                  <div className="flex-shrink-0 h-6 w-6 flex items-center justify-center rounded-full bg-[#00c853]/20 text-[#00c853]" data-id="element-700">
                    <CheckIcon className="w-4 h-4" data-id="element-701" />
                  </div>
                  <p className="text-lg text-gray-300" data-id="element-702">{criterion}</p>
                </div>)}
            </div>
          </div>
          <p className="text-xl text-gray-200 text-center mt-12" data-id="element-703">
            If that sounds like you—we'll help you own your sourcing funnel from
            top to bottom.
          </p>
        </div>
      </Container>
    </section>;
};